/* src/app/shop/productos/products-in-pack/products-in-pack.component.scss */
.pack-container {
  border-radius: 15px;
  background-color: white;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.3019607843);
  gap: 15px;
}
.title {
  font-family: Barlow Semi Condensed;
  font-size: clamp(1.125rem, 1.0714rem + 0.2597vw, 1.25rem);
  font-weight: 500;
  line-height: 24px;
}
.product-card {
  border: 1px solid #cbcbcb;
  border-radius: 10px;
  padding: 10px;
  gap: 15px;
}
img {
  width: 54px;
  scale: 1/1;
}
.product-name {
  font-family: Barlow Semi Condensed;
  font-size: clamp(1rem, 0.9464rem + 0.2597vw, 1.125rem);
  font-weight: 500;
  line-height: 21.6px;
  text-align: left;
}
.img-title {
  gap: 15px;
}
.product-price {
  font-family: League Spartan;
  font-size: clamp(1rem, 0.9464rem + 0.2597vw, 1.125rem);
  font-weight: 500;
  line-height: 16.56px;
  color: #949494;
  white-space: nowrap;
}
/*# sourceMappingURL=products-in-pack.component-PWOLBRFR.css.map */
